var ErrrorValidation;
(function (ErrrorValidation) {
    var Controller = (function () {
        function Controller() {
            this.oldLabel = {};
            var _this = this;
        }

        Controller.prototype.GetOldLabel = function (key) {
            var _this = this;
            return _this.oldLabel[key];
        }

        Controller.prototype.StoreOldLabel = function (key, value) {
            var _this = this;
            _this.oldLabel[key] = value;
        }

        Controller.prototype.AddError = function (inputWrapper, labelElement, errorMessage) {
            var input = inputWrapper.find('.inputBox');
            input.addClass('inputError');
            labelElement.addClass('labelError');
            if (errorMessage !== "")
                labelElement.text(errorMessage);
            var iconContainer = inputWrapper.find('i');
            iconContainer.css('display', 'inline');
        }

        Controller.prototype.AddSuccess = function (inputElement, labelElement, successMessage) {
            inputElement.addClass('inputSuccess');
            labelElement.addClass('labelSuccess');
            labelElement.text(successMessage);
        }

        Controller.prototype.ResetAll = function (inputWrapper, labelElement, resetInput) {
            var _this = this;
            var inputElement = inputWrapper.find('.inputBox');
            inputElement.removeClass('inputSuccess');
            inputElement.removeClass('inputError');
            labelElement.removeClass('labelError');
            labelElement.removeClass('labelSuccess');
            for (var i = 0; i < labelElement.length; i++) {
                $(labelElement[i]).text(_this.oldLabel[$(labelElement[i]).attr('id')]);
            }
            var iconContainer = inputWrapper.find('i');
            iconContainer.hide();
            if (resetInput)
                inputElement.val("");
        }

        Controller.prototype.ResetErrorBox = function (errorBoxElement) {
            errorBoxElement.removeClass('active');
        }


        Controller.prototype.SuccessShowHide = function (removeClass, addClass) {
            var _this = this;

            $('#successOverlays').removeClass(removeClass);
            $('#successTriangle').removeClass(removeClass);
            $('.feedBackBoxSuccess').removeClass(removeClass);
            $('#successOverlays').addClass(addClass);
            $('#successTriangle').addClass(addClass);
            $('.feedBackBoxSuccess').addClass(addClass);
        }

        Controller.prototype.FailedShowHide = function (removeClass, addClass) {
            $('#failedOverlays').removeClass(removeClass);
            $('#failedTriangle').removeClass(removeClass);
            $('.feedBackBoxFailed').removeClass(removeClass);
            $('#failedOverlays').addClass(addClass);
            $('#failedTriangle').addClass(addClass);
            $('.feedBackBoxFailed').addClass(addClass);
        }

        Controller.prototype.ErrorValidationToggle = function (display, hidden) {
            $(hidden).AddClass('hidden');
            if (typeof display == 'Array') {
                $('#' + display.join(', #')).removeClass('hidden');
            } else {
                $('.' + display).removeClass('hidden');
            }
        }
        return Controller;
    })();
    ErrrorValidation.Controller = Controller;
})(ErrrorValidation || (ErrrorValidation = {}));